import { render, staticRenderFns } from "./CommissionAssign.vue?vue&type=template&id=1729297a&scoped=true&"
import script from "./CommissionAssign.vue?vue&type=script&lang=js&"
export * from "./CommissionAssign.vue?vue&type=script&lang=js&"
import style0 from "./CommissionAssign.vue?vue&type=style&index=0&id=1729297a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729297a",
  null
  
)

export default component.exports